// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/styles/DropArea.scss
// module id = 71
// module chunks = 0